export type Profile = {
  id: string
  name: string
  bgColor: string
  textColor: string
  link?: string
}

export const WorkspaceProfiles: Profile[] = [
  {
    id: '0',
    name: 'Administrador',
    bgColor: '#D4EDFA',
    textColor: '#39ACE5',
    link: 'https://londrisoft.octadesk.com/kb' ,
  },
  {
    id: '1',
    name: 'Usuário',
    bgColor: '#B5FFD2',
    textColor: '#41B971',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '999',
    name: 'Selecione',
    bgColor: '#DED4F9',
    textColor: '#A68FE5',
    link: 'https://londrisoft.octadesk.com/kb',
  },
]

export const GestorProfiles: Profile[] = [
  {
    id: '1',
    name: 'Administrador',
    bgColor: '#D4EDFA',
    textColor: '#39ACE5',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '2',
    name: 'Cadastro',
    bgColor: '#FCD9FF',
    textColor: '#EF73FA',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '3',
    name: 'Faturamento',
    bgColor: '#B5FFD2',
    textColor: '#41B971',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    name: 'PDV',
    id: '4',
    bgColor: '#B5FFD2',
    textColor: '#41B971',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    name: 'NF-e',
    id: '5',
    bgColor: '#FAF2D4',
    textColor: '#E5C245',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '6',
    name: 'Financeiro',
    bgColor: '#FFD9D9',
    textColor: '#E57373',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '7',
    name: 'Indústria',
    bgColor: '#DED4F9',
    textColor: '#A68FE5',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '999',
    name: 'Selecione',
    bgColor: '#DED4F9',
    textColor: '#A68FE5',
    link: 'https://londrisoft.octadesk.com/kb',
  },
]

export const UniqueProfiles: Profile[] = [
  {
    id: '1',
    name: 'Administrador',
    bgColor: '#D4EDFA',
    textColor: '#39ACE5',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '2',
    name: 'Cadastro',
    bgColor: '#FCD9FF',
    textColor: '#EF73FA',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '3',
    name: 'Folha',
    bgColor: '#B5FFD2',
    textColor: '#41B971',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '4',
    name: 'Fiscal',
    bgColor: '#FAF2D4',
    textColor: '#E5C245',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '5',
    name: 'Contábil',
    bgColor: '#FFD9D9',
    textColor: '#E57373',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '6',
    name: 'Contábil Físcal',
    bgColor: '#DED4F9',
    textColor: '#A68FE5',
    link: 'https://londrisoft.octadesk.com/kb',
  },
  {
    id: '999',
    name: 'Selecione',
    bgColor: '#DED4F9',
    textColor: '#A68FE5',
    link: 'https://londrisoft.octadesk.com/kb',
  },
]
